<template>
    <div class="mb-5">
        <h1 class="page-title">Gérer les carrousels</h1>
    </div>
    <div class="flex justify-end">


        <Button
            label="Ajouter un carrousel"
            @click="type == 'login' ? router.push({ name: 'addCarouselLogin' }) : router.push({ name: 'addCarousel' })"
            icon="pi pi-plus"
            class="button-add"
        />
    </div>
    <div class="card">
        <DataTable
            lazy
            :value="tableData"
            :paginator="true"
            :rows="rows"
            removableSort
            :loading="isLoading"
            :totalRecords="totalRecords"
            :currentPage="currentPage"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 25, 100]"
            currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} entrées"
            @page="onPaginate($event)"
            @sort="onSort($event)"
        >
           

            <div class="card-body pt-0">
                <Column field="vignette" header="Miniature">
                    <template #body="slotProps">
                        <img v-if="slotProps.data.imageWeb" :src="slotProps.data.imageWeb.url" class="w-14" />
                    </template>
                </Column>
                <Column field="position" header="Position">
                    <template #body="slotProps">
                        <span> {{ slotProps.data.position }} </span>
                    </template>
                </Column>
                <Column field="domaine" header="Platforme" v-if="type == 'login'">
                    <template #body="slotProps">
                        <span> {{ slotProps.data.domaine }} </span>
                    </template>
                </Column>
                <Column field="action" header="Action">
                    <template #body="slotProps">
                        <div class="d-flex flex-row">
                            <Button size="small" icon="pi pi-pencil" class="p-edition"
                                    style="margin-right: 0.5em" title="Éditer"
                                    @click="type == 'login' ? router.push({ name: 'editCarouselLogin', params: { uuid: slotProps.data.uuid } }) : router.push({ name: 'editCarousel', params: { uuid: slotProps.data.uuid } })">
                            </Button>
                            <Button size="small" icon="pi pi-trash" class="p-button-danger"
                                    style="margin-right: 0.5em" title="supprimer" @click="onDelete(slotProps.data)">
                            </Button>
                            <InputSwitch
                                v-model="slotProps.data.active"
                                :input-id="slotProps.data.uuid"
                                @input="changeState(slotProps.data.uuid, slotProps.data.active)"
                            />
                        </div>
                    </template>
                </Column>
            </div>
            <template #empty>Aucun produit ne correspond à votre recherche</template>
        </DataTable>
    </div>
</template>
<script setup lang="ts">
import DataTable from "primevue/datatable";
import {ref, onMounted, computed, watch} from 'vue';
import Button from "primevue/button";
import Column from "primevue/column";
import router from "@/router";
import swal from "@/_helpers/swal";
import InputSwitch from "primevue/inputswitch";
import {changeStateCarousel, deleteCarousel, fetchCarousel} from "@/_services/homepage/carousel";
import {ICarousel} from "@/models/homepage/ICarousel";
import {useRoute} from "vue-router";
const carousel = Array<ICarousel>();
const tableData = ref<Array<ICarousel>>(carousel);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const totalRecords = ref<number>(0);
const currentPage = ref<number>(0);
const criteria = ref<string>("");
const page = ref<number>(1);
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[createdAt]",
    fieldValue: "desc",
};
const route = useRoute()
const type = computed(() => route.meta?.type as string | undefined)


onMounted(async () => {
    await populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

watch(() => route.meta.type, () => {
    populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
});

const populateDatatable = async (itemsPerPage, page, criteria?, sort?) => {
    isLoading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchCarousel(
        itemsPerPage,
        page,
        criteria,
        sort,
        type.value
    );
    totalRecords.value = totalRecordsDt.value;
    tableData.value = tableDataDt.value;
    isLoading.value = loadingDt.value;
};

async function onPaginate(e) {
    rows.value = e.rows;
    populateDatatable(e.rows, e.page + 1, criteria.value, defaultsSort);
}

const onSort = (e) => {
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, criteria.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, criteria.value, defaultsSort);
    }
};

const changeState = async (uuid: string, isActive: boolean) => {
    let currentStateBeforeSave = !isActive;
    const confirmationMessage = currentStateBeforeSave
        ? "Êtes-vous sûr de vouloir désactiver ce carrousel ?"
        : "Êtes-vous sûr de vouloir activer ce carrousel ?";
    const result = await swal.confirm(confirmationMessage);
    if (result.isConfirmed) {
        await changeStateCarousel(uuid, isActive);
        const successMessage = isActive
            ? "Vous venez d'activer un carrousel."
            : "Vous venez de désactiver un carrousel.";

        swal.success("Opération réussie !", successMessage);
    }
    populateDatatable(
        rows.value,
        page.value,
        "" != criteria.value ? criteria.value : ""
    );
};

const onDelete = (data: ICarousel) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer ?")
        .then((result) => {
            if (result.isConfirmed) {
                deleteCarousel(data.uuid).then((result) => {
                    swal.success("succés !", "Suppression effectuée avec succès");
                    populateDatatable(
                        rows.value,
                        page.value,
                        "" != criteria.value ? criteria.value : ""
                    );
                });
            }
        });
};
</script>